import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { NzNotificationService } from 'ng-zorro-antd/notification';

import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../../auth/_services/authentication.service';
import {ApiService} from '../../shared/_services/api.service';

@Component({
  selector: 'app-switch-portal',
  templateUrl: './switch-portal.component.html',
  styleUrls: ['./switch-portal.component.less']
})
export class SwitchPortalComponent implements OnDestroy {

  private subscribe: Subscription;
  private winRef: Window;
  expand: boolean;

  constructor(
    private notification: NzNotificationService,
    private api: ApiService) {
  }

  openInNewTab(url): void {
    if (typeof (this.winRef) === 'undefined' || this.winRef?.closed || this.winRef == null) {
      this.winRef = window.open(url, '_blank');
    } else {
      this.winRef.focus();
    }
  }

  openSpearAdInNewTab(): void {
    let spearadUrlWithToken = environment.spearadUrl;
    const portalHomeUrl = window.location.href.substring(0, window.location.href.indexOf('.co/portal') + 10);
    this.subscribe = this.api.generateSpearadToken().subscribe(tokenRes => {
        spearadUrlWithToken = spearadUrlWithToken + `?token=${tokenRes.spearadToken}&refUrl=${portalHomeUrl}`;
        this.openInNewTab(spearadUrlWithToken);
        this.expand = false;
      },
      () => {
        this.notification.error('Authentication Failed', 'Spearad login failed');
      });
  }

  ngOnDestroy(): void {
    if (this.subscribe) {
      this.subscribe.unsubscribe();
    }
  }
}
